export default "__VITE_ASSET__6Ewd5UjP__"